import { Injectable } from '@angular/core';

import { BestOddsGuaranteedToken } from '../../../reward-tokens.model';
import { DayOfWeekValidator } from '../criteria/best-odds-guaranteed/day-of-week-validator.service';
import { SportsBestOddsGuaranteeValidator } from '../criteria/best-odds-guaranteed/sports-validator.service';
import { TimeOfDayValidator } from '../criteria/best-odds-guaranteed/time-of-day-validator.service';
import { ExpiryDateValidator } from '../criteria/expiry-date-validator.service';
import { MultiSlipTypeValidator } from '../criteria/multi-slip-type-validator.service';
import { StartDateValidator } from '../criteria/start-date-validator.service';
import { TokenValidator } from '../token-validator.service';

@Injectable()
export class BestOddsGuaranteedTokenValidator extends TokenValidator<BestOddsGuaranteedToken> {
    constructor(
        slipTypeValidator: MultiSlipTypeValidator,
        startDateValidator: StartDateValidator,
        expiryDateValidator: ExpiryDateValidator,
        daysOfWeekValidator: DayOfWeekValidator,
        timeOfDayValidator: TimeOfDayValidator,
        sportsValidator: SportsBestOddsGuaranteeValidator,
    ) {
        super();

        this.hardCriteriaValidators.push(slipTypeValidator);
        this.hardCriteriaValidators.push(startDateValidator);
        this.hardCriteriaValidators.push(expiryDateValidator);
        this.hardCriteriaValidators.push(daysOfWeekValidator);
        this.hardCriteriaValidators.push(timeOfDayValidator);
        this.hardCriteriaValidators.push(sportsValidator);
    }
}
